module.exports = __webpack_public_path__ + "img/purchase_curriculum.c252b32a.png";